module.exports = __webpack_public_path__ + "static/smart-nudge-20322ff09b1d0502ad047a86208be27e.gif";